import polyglotI18nProvider from "ra-i18n-polyglot";
import en from 'ra-language-english';

const translations = { en, };

const i18nProvider = polyglotI18nProvider(
    locale => translations[locale],
    'en', // default locale
    [
        { locale: 'en', name: 'English' },
        { locale: 'es', name: 'Español' }
    ],
);

export default i18nProvider;